import { render, staticRenderFns } from "./CreateFormulario.vue?vue&type=template&id=1dec8d94&scoped=true"
import script from "./CreateFormulario.vue?vue&type=script&lang=js"
export * from "./CreateFormulario.vue?vue&type=script&lang=js"
import style0 from "./CreateFormulario.vue?vue&type=style&index=0&id=1dec8d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec8d94",
  null
  
)

export default component.exports